// extracted by mini-css-extract-plugin
export var connectionButton = "_99-1";
export var rightPanel = "_99-3";
export var stepDescription = "_99-2";
export var stepIcon = "_99-0";